import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class GoalsService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdGoals(goalId): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Goals/deleteGoals', {'goalId': goalId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countGoals(goals): Observable<number> {
        return this.httpClient.post<number>(Constant.BASE_URL + 'Goals/count', {'goals': goals}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    updateGoals(goals, refData): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Goals/updateGoals', [goals, refData], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addGoals(goals, refData): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Goals/addGoals', [goals, refData], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findAllGoals(goals, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'Goals/findAllGoals', {'goals': goals, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}},
            this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

    // custom service for global search

    globalSearchCount(searchTerm,appointmentId,expertId,patientId): Observable<number> {
        return this.httpClient.post<number>(
            Constant.BASE_URL + 'Goals/countGlobalGoals',
            {'searchTerm': searchTerm,'appointmentId':appointmentId,'expertId':expertId,'patientId':patientId},
            this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

    globalSearchFind(searchTerm,appointmentId,expertId,patientId, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'Goals/findGlobalGoals',
            {'searchTerm': searchTerm,'appointmentId':appointmentId,'expertId':expertId,'patientId':patientId,
                'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}},
            this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

}
